import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  GoalTrack = 'GoalTrack',
}

export const queryKeys = {
  goalTrack: (clientId: number) => [QueryFeature.GoalTrack, QueryKey.GoalTrack, clientId],
};
